export function MyloLogoLoader() {
  return (
    <section style={loaderSection}>
      <div style={loaderBox}>
        <img style={loaderImage} src="/images/loader_gif.gif" alt="" />
      </div>
    </section>
  );
}

const loaderSection = {
  position: 'fixed',
  top: '0',
  left: '0',
  height: '100%',
  width: '100%',
  zIndex: '9',
  background: ' rgba(0,0,0,0.4)',
};
const loaderBox = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: ' translate(-50%, -50%)',
  WebkitTransform: 'translate(-50%, -50%)',
  MozTransform: 'translate(-50%, -50%)',
  width: '75px',
};
const loaderImage = {
  width: '100%',
  borderRadius: '50px',
};
